import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100vh;
`;

export const HeaderSection = styled.section`
  display: flex;
  padding: 2rem;
  justify-content: space-between;
`;

export const SectionBodyContainer = styled.section`
  display: flex;
  flex-direction: column;
  padding: 1rem 4rem;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  overflow-y: scroll;
`;

export const ContainerFilterButton = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const FilterButton = styled.button`
  display: flex;
  z-index: 3;
  align-items: center;
  justify-content: space-around;
  border-radius: 16px;
  padding: 0.5rem 1rem;
  width: 150px;
  height: fit-content;
  background-color: #fff;

  font-size: 1.25rem;
  color: #808080;
  border: 0px;
  position: absolute;
  top: 0.5;
  right: 0;
  ${(props: { isOpen: boolean }) =>
    props.isOpen
      ? "box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.25)"
      : "box-shadow:0 4px 4px 0 rgba(0, 0, 0, 0.25)"};
`;

export const FilterOptionContainer = styled.div`
  width: 300px;
  height: fit-content;
  background-color: #fff;
  padding: 2rem 1.5rem 0.5rem 1.5rem;
  z-index: 2;
  border-radius: 16px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 3rem;
  right: 0;
`;

export const FormCheckFragment = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  div.line {
    height: 2px;
    width: 100%;
    background-color: #ccc;
    margin: 0.5rem 0 1rem 0;
  }
`;
export const LabelFormCheck = styled.div`
  font-size: 1.125rem;
  color: #123559;
`;

export const ContainerSeachData = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerSearce = styled.div`
  display: flex;
  align-items: center;
  & > p {
    margin: 0;
    color: #123559;
    margin-right: 1rem;
  }
`;
export const SearchInput = styled.input`
  border: none;
  border-radius: 2rem;
  padding: 0.5rem 1rem;
  outline: none;
  ::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    font-size: 0.75rem;
    color: #ddd;
  }
  ::-moz-placeholder {
    /* Firefox 19+ */
    font-size: 0.75rem;
    color: #ddd;
  }
  :-ms-input-placeholder {
    /* IE 10+ */
    font-size: 0.75rem;
    color: #ddd;
  }
  :-moz-placeholder {
    /* Firefox 18- */
    font-size: 0.75rem;
    color: #ddd;
  }
`;

export const ButtonContainer = styled.div`
  ${(props: { activestate: boolean }) =>
    !props.activestate
      ? "background-color: #0dd07e"
      : "background-color: #fff"};
  ${(props: { activestate: boolean }) =>
    !props.activestate ? "color: #fff" : "color: #0dd07e"};

  border-radius: 1rem;
  border: 2px solid #0dd07e;
  margin-top: 1rem;
  cursor: pointer;
  text-align: center;
  padding: 0.5rem 1rem;
  width: 10rem;
  align-self: center;
`;
